var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarLidar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.62598 4.09313C4.62598 3.53188 5.08095 3.0769 5.6422 3.0769H14.5341C15.0954 3.0769 15.5504 3.53188 15.5504 4.09313V6.37963C15.5504 6.94087 15.0954 7.39585 14.5341 7.39585H13.8433C13.8712 7.51512 13.8777 7.64185 13.8591 7.77144L13.6432 9.27268C13.5713 9.77291 13.1427 10.1443 12.6374 10.1443H12.5645L12.5009 10.7971C12.4502 11.3177 12.0126 11.7148 11.4895 11.7148H8.68684C8.16375 11.7148 7.72611 11.3177 7.6754 10.7971L7.61181 10.1443H7.53897C7.0336 10.1443 6.60502 9.77291 6.53309 9.27268L6.31723 7.77144C6.2986 7.64185 6.30518 7.51512 6.333 7.39585H5.6422C5.08095 7.39585 4.62598 6.94087 4.62598 6.37963V4.09313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5232 7.14179H14.5341C14.9551 7.14179 15.2963 6.80056 15.2963 6.37963V4.09313C15.2963 3.67219 14.9551 3.33096 14.5341 3.33096H5.6422C5.22127 3.33096 4.88003 3.67219 4.88003 4.09313V6.37963C4.88003 6.80056 5.22127 7.14179 5.6422 7.14179H6.65314L6.58041 7.45356C6.55967 7.5425 6.55462 7.63739 6.5687 7.73529L6.78456 9.23652C6.83851 9.61169 7.15994 9.89021 7.53897 9.89021H7.84232L7.92826 10.7725C7.96629 11.1629 8.29452 11.4607 8.68684 11.4607H11.4895C11.8818 11.4607 12.21 11.1629 12.2481 10.7725L12.334 9.89021H12.6374C13.0164 9.89021 13.3378 9.61169 13.3918 9.23652L13.6076 7.73529C13.6217 7.63739 13.6167 7.5425 13.5959 7.45356L13.5232 7.14179ZM14.5341 7.39585C15.0954 7.39585 15.5504 6.94087 15.5504 6.37963V4.09313C15.5504 3.53188 15.0954 3.0769 14.5341 3.0769H5.6422C5.08095 3.0769 4.62598 3.53188 4.62598 4.09313V6.37963C4.62598 6.94087 5.08095 7.39585 5.6422 7.39585H6.333C6.31395 7.47753 6.30485 7.5627 6.307 7.6499C6.30799 7.69004 6.31136 7.7306 6.31723 7.77144L6.5331 9.27268C6.60502 9.77291 7.0336 10.1443 7.53897 10.1443H7.61181L7.6754 10.7971C7.72611 11.3177 8.16375 11.7148 8.68684 11.7148H11.4895C12.0126 11.7148 12.4502 11.3177 12.5009 10.7971L12.5645 10.1443H12.6374C13.1427 10.1443 13.5713 9.77291 13.6432 9.27268L13.8591 7.77144C13.865 7.7306 13.8684 7.69004 13.8693 7.6499C13.8715 7.5627 13.8624 7.47753 13.8433 7.39585H14.5341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.949707 15.9927L4.76054 4.81421L5.00101 4.89619L1.19017 16.0746L0.949707 15.9927Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2271 15.9941L15.5432 4.81567L15.302 4.89519L18.9858 16.0736L19.2271 15.9941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83 16.7959H0.305664L1.06783 16.0337L1.83 16.7959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.06884 15.8542L2.13768 16.9231H0L1.06884 15.8542ZM0.613344 16.669H1.52433L1.06884 16.2135L0.613344 16.669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8505 15.7797H9.32617L10.0883 15.0176L10.8505 15.7797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0874 14.8379L11.1562 15.9067H9.01855L10.0874 14.8379ZM9.6319 15.6527H10.5429L10.0874 15.1972L9.6319 15.6527Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7421 16.542H18.2178L18.9799 15.7798L19.7421 16.542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9795 15.6001L20.0483 16.6689H17.9106L18.9795 15.6001ZM18.524 16.4149H19.435L18.9795 15.9594L18.524 16.4149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.96045 15.1447V11.5879H10.2145V15.1447H9.96045Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.11722 10.1901L8.03026 10.8264L7.99763 11.0784L3.08459 10.442L3.11722 10.1901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.11722 10.1901L8.03026 10.8264L7.99763 11.0784L3.08459 10.442L3.11722 10.1901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.144 10.1901L12.231 10.8264L12.2636 11.0784L17.1766 10.442L17.144 10.1901Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarLidar);
export default __webpack_public_path__ + "static/media/sidebar-lidar.0ac55b80.svg";
export { ForwardRef as ReactComponent };